export default {
  // FORM HEADER
  get_tncli: state => {return state.form_header.tncli},
  get_tnosal: state => {return state.form_header.tnosal},
  get_tnomc: state => {return state.form_header.tnomc},
  get_tclang: state => {return state.form_header.tclang},
  get_tcdev: state => {return state.form_header.tcdev},
  get_tsiret: state => {return state.form_header.tsiret},
  get_ttvacee: state => {return state.form_header.ttvacee},
  get_tweb: state => {return state.form_header.tweb},
  get_tcdiv: state => {return state.form_header.tcdiv},
  get_tcsdiv: state => {return state.form_header.tcsdiv},
  get_tadr1l: state => {return state.form_header.tadr1l},
  get_tadr2l: state => {return state.form_header.tadr2l},
  get_tadr3l: state => {return state.form_header.tadr3l},
  get_tcpostl: state => {return state.form_header.tcpostl},
  get_tvillel: state => {return state.form_header.tvillel},
  get_tcpaysl: state => {return state.form_header.tcpaysl},
  get_tadr1f: state => {return state.form_header.tadr1f},
  get_tadr2f: state => {return state.form_header.tadr2f},
  get_tadr3f: state => {return state.form_header.tadr3f},
  get_tcpostf: state => {return state.form_header.tcpostf},
  get_tvillef: state => {return state.form_header.tvillef},
  get_tcpaysf: state => {return state.form_header.tcpaysf},
  get_tccom: state => {return state.form_header.tccom},
  get_tca: state => {return state.form_header.tca},
  get_tnb_emp: state => {return state.form_header.tnb_emp},
  get_tlieuprod: state => {return state.form_header.tlieuprod},
  get_taut_four: state => {return state.form_header.taut_four},
  get_ttop_grat: state => {return state.form_header.ttop_grat},
  get_telectro: state => {return state.form_header.telectro},
  get_tcom: state => {return state.form_header.tcom},
  get_ttop_ac: state => {return state.form_header.ttop_ac},
  get_ttop_adv: state => {return state.form_header.ttop_adv},
  get_ttop_cda: state => {return state.form_header.ttop_cda},
  get_ttop_rdv: state => {return state.form_header.ttop_rdv},
  get_tcprovl: state => {return state.form_header.tcprovl},
  get_tcprovf: state => {return state.form_header.tcprovf},
  get_header: state => {return state.form_header},

  // FORM CONTACT 
  get_contact: state => {return state.form_contact},
  // FORM TYPOLOGY 
  get_typology: state => {return state.form_typology},
  // FORM CARD 
  get_card: state => {return state.form_card},
  // FORM SAMPLE 
  get_sample: state => {return state.form_sample},
  // FORM ATTACHMENT 
  get_attachment: state => {return state.form_attachment},
  // FORM SPECIAL REQUEST 
  get_special_request: state => {return state.form_special_request},
}